module.exports = {
  datatrans: {
    paymentUrl: 'https://payment.datatrans.biz/upp/jsp/upStart.jsp',
    merchantId: '3000000897',
    sign: '50822202209798088',
  }
}
